import * as Sentry from '@sentry/react';
import { EnvironmentHelper } from '../Helpers/EnvironmentHelper';

export const initSentry = (appName: string) => {
    if (EnvironmentHelper.isLocalDev()) {
        return;
    }

    Sentry.init({
        dsn: 'https://07d62a5de2ac038ff68df35300865b99@o4508806554845184.ingest.de.sentry.io/4509162261905488',
        environment: '__ENV__',
        release: '__BUILD_ID__',
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
        initialScope: (scope) => {
            scope.setTag('client', appName);
            return scope;
        },
    });
};
